import { library } from '@fortawesome/fontawesome-svg-core';
import { fad } from '@fortawesome/pro-duotone-svg-icons';

library.add(fad);

export const getIconFromName = (name: string) => {
    return fad[name];
};
